import { fetch } from '@/middleware';

import { mutationMapper } from '@/utils/vuex';
import {
    FETCH_UPDATE,
    FETCH_SUCCESS,
    FETCH_FAILURE,
    SUCCESS_NOTIFICATION,
    FAILURE_NOTIFICATION,
} from '@/store/actions';
import Config from '@/config';

const SET_LOADER = 'SET_LOADER';

export const ServiceModule = {
    namespaced: true,
    state: {
        pending: [],
        message: {},
        messageTimeout: Config.SYSTEM_MESSAGE.LIFE_SPAN,
        isLoading: false
    },
    actions: { 
      set_loader({commit}, isLoading) {
       commit(SET_LOADER, isLoading); 
      } 
    },
    mutations: {
        ...mutationMapper([
            FETCH_UPDATE,
            FETCH_SUCCESS
        ], (state) => {
            setTimeout(() => {
                state.pending = [...fetch.observer];
            });
        }),

        ...mutationMapper([
          FETCH_FAILURE,
          FAILURE_NOTIFICATION
        ], (state, error) => {
          state.message = {
            type: 'error',
            value: error
          };
          setTimeout(() => {
            state.pending = [...fetch.observer];
          });
        }),

        [SUCCESS_NOTIFICATION]: (state, success) => {
          state.message = {
            type: 'success',
            value: success
          }
          
          setTimeout(() => {
            state.messageTimeout = Config.SYSTEM_MESSAGE.LIFE_SPAN;
          }, state.messageTimeout);
        },
        [SET_LOADER]: (state, isLoading) => {
          state.isLoading = isLoading; 
        },
        setSystemMessageTimeout: (state, timeout) => {
          state.messageTimeout = timeout;
        },
    },

    getters: {
        GET_PENDING_SERVICE: state => state.pending,
        GET_SYSTEM_MESSAGE: state => state.message,
        GET_SYSTEM_MESSAGE_TIMEOUT: state => state.messageTimeout,
        GET_LOADING_STATUS: state => state.isLoading
    }
}
